// extracted by mini-css-extract-plugin
module.exports = {"left":"_3DVMm7VQa2EGu5o0A6Kzn","up":"_1lLTHJVquXvGcRNhIIb42f","down":"_34poK-b-Dd0TEH3VYxAnOL","clickable":"_1-niAFHWpF7t9wovreCeiB"};